<template>
	<div id="page-user-edit">
		<template v-if="activeTab === 0">
			<bread-crumbs
				:title="$t('StatusMobile.StatusMobile')"
				:subTitle="$t('general.SubtitleStatusMobile')"
				:sizeTitle="30"
				:lineHeightTitle="37"
				:sizeSubTitle="15"
				:lineHeightSubTitle="18"
			></bread-crumbs>
			<div class="vx-col w-full mb-4">
				<vs-button type="filled" class="g-btn-customize p-0" @click.prevent="activeTab = 1">
					{{ $t("StatusMobile.FormStatusMobile.CreateStatusMobile") }}
				</vs-button>
			</div>
		</template>
		<div class="vx-card p-4">
			<div v-if="activeTab === 0" class="tab-text">
				<status-mobile-list-view
					v-if="statusMobileReadPermission"
					:data="statusMobileData"
					@selectedStatusMobileEmit="selectedStatusMobile"
				/>
				<not-permission v-else></not-permission>
			</div>
			<div v-else-if="activeTab === 1" class="tab-text">
				<status-mobile-form
					v-if="statusMobileCreatePermission && !editable"
					:statusMobile="statusMobile"
					:editable="editable"
					@cancelEditEmit="cancelEdit"
					@changeActiveTabEmit="valueStatusMobileEmit"
				/>
				<status-mobile-form
					v-else-if="statusMobileUpdatePermission && editable"
					:statusMobile="statusMobile"
					:editable="editable"
					@cancelEditEmit="cancelEdit"
					@changeActiveTabEmit="valueStatusMobileEmit"
				/>
				<not-permission v-else></not-permission>
			</div>
		</div>
	</div>
</template>

<script>
import StatusMobileListView from "./StatusMobileListView.vue";
import StatusMobileForm from "./StatusMobileForm.vue";
import StatusMobile from "@/models/StatusMobile.js";
import moduleStatusMobile from "@/store/status-mobile/moduleStatusMobile.js";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	data() {
		return {
			statusMobile: new StatusMobile({}),
			statusMobileData: {},
			activeTab: 0,
			editable: false,
		};
	},
	components: {
		StatusMobileListView,
		StatusMobileForm,
		NotPermission,
	},
	computed: {
		statusMobileReadPermission() {
			return this.$store.getters.checkPermission("STATUSMOBILE_R");
		},
		statusMobileCreatePermission() {
			return this.$store.getters.checkPermission("STATUSMOBILE_C");
		},
		statusMobileUpdatePermission() {
			return this.$store.getters.checkPermission("STATUSMOBILE_U");
		},
	},
	methods: {
		// Cargar
		loading() {
			this.$vs.loading();
		},
		// cerrar cargar
		closeLoading() {
			this.$vs.loading.close();
		},
		// Selecciona status
		selectedStatusMobile(statusMobile) {
			this.activeTab = 1;
			this.editable = true;
			this.statusMobile = new StatusMobile(statusMobile);
		},
		valueStatusMobileEmit(val) {
			this.activeTab = val;
			if (this.activeTab === 0) {
				this.statusMobile = new StatusMobile({});
			}
		},
		// cancelar edicion
		cancelEdit() {
			this.editable = false;
			this.activeTab = 0;
			this.statusMobile = new StatusMobile({});
		},
		// Consultar status mobile
		consultStatusMobile() {
			this.loading();
			// Consulta los estados para moviles
			this.$store
				.dispatch("moduleStatusMobile/getStatusMobile")
				.then((res) => {
					//this.closeLoading();
					this.consultStatus();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		// consultar status
		consultStatus() {
			//this.loading();
			// Consultar los estados
			this.$store
				.dispatch("moduleStatusMobile/getStatus")
				.then((res) => {
					//this.closeLoading();
					this.consultCompanies();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		// consultar compañias
		consultCompanies() {
			//this.loading();
			// Consultar los estados
			this.$store
				.dispatch("moduleStatusMobile/getCompanies")
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
	},
	created() {
		// Se registra el modulo
		if (!moduleStatusMobile.isRegistered) {
			this.$store.registerModule("moduleStatusMobile", moduleStatusMobile);
			moduleStatusMobile.isRegistered = true;
		}
		// Consultar status mobibile cuando se inicia
		this.consultStatusMobile();
	},
};
</script>
